import * as amplitude from '@amplitude/analytics-browser';
import { isOpenInTelegram } from '../utils/isOpenInTelegram';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

// Custom Amplitude config
const config: amplitude.Types.BrowserOptions = {
  defaultTracking: true,
};

export const initAmplitude = async (key: string, nodeEnv?: string) => {
  try {
    const isProdOrStaging = nodeEnv === 'production' || nodeEnv === 'staging';

    const sessionReplayTracking = sessionReplayPlugin({
      // In Dev: Hardcoded to 100%
      // In Prod/Staging: 'undefined' prioritizes Remote Config.
      // WARNING: If Remote Config fails to load, Amplitude natively falls back to 0%.
      sampleRate: isProdOrStaging ? undefined : 1,
      // For inline styles active in replays
      shouldInlineStylesheet: true,
      // Performance config - moving compression off the main thread
      useWebWorker: true,
    });

    amplitude.init(key, undefined, {
      ...config,
      remoteConfig: {
        fetchRemoteConfig: isProdOrStaging,
      },
    });

    // Turn on replays only in production or staging builds
    if (!isProdOrStaging) {
      return;
    }

    await amplitude.add(sessionReplayTracking).promise;
  } catch {
    // Analytics must never break the app — swallow init failures
    // (invalid key, blocked network, remote config 4xx, etc.)
  }
};

export const analytics = {
  ...amplitude,
  track: (name: string, eventProperties?: any) => {
    try {
      const isTelegram = isOpenInTelegram();

      const eventName = `web_${name}`;
      return amplitude.track(eventName, {
        source: isTelegram ? 'telegram' : 'web',
        ...eventProperties,
      });
    } catch {
      return undefined;
    }
  },
};
